import { useLocation } from 'react-router-dom';
import Sidebar from './sidebar';

const TITLES = {
  '/':           { title: 'Dashboard',             sub: 'Ecosystem overview' },
  '/content':    { title: 'Pages & Content',        sub: 'Manage SPA pages and sections' },
  '/articles':   { title: 'Articles & Media',       sub: 'News, insights, and publications' },
  '/services':   { title: 'Services',               sub: 'Service catalog and SKU management' },
  '/ecosystem':  { title: 'Ecosystem Entities',     sub: 'Brands, platforms, and sub-brands' },
  '/programs':   { title: 'Programs & Training',    sub: 'Training programs and cohorts' },
  '/inbox':      { title: 'Inbox & Applications',   sub: 'Contact messages and applications' },
  '/donations':  { title: 'Donations',              sub: 'Financial contributions and packages' },
  '/users':      { title: 'Users & Roles',          sub: 'Access control and team management' },
  '/activity':   { title: 'Activity Log',           sub: 'Full admin audit trail' },
};

export default function AppLayout({ children }) {
  const location = useLocation();
  const match = Object.entries(TITLES)
    .sort((a, b) => b[0].length - a[0].length)
    .find(([path]) => location.pathname === path || (path !== '/' && location.pathname.startsWith(path)));
  const info = match?.[1] || { title: 'MilleHills Admin', sub: '' };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <div style={{
        marginLeft: 'var(--sidebar-w)',
        flex: 1, minWidth: 0,
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Header */}
        <header style={{
          height: 'var(--header-h)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 28px',
          borderBottom: '1px solid var(--border)',
          background: 'var(--bg-base)',
          position: 'sticky', top: 0, zIndex: 50,
        }}>
          <div>
            <h1 style={{
              fontFamily: 'var(--font-display)', fontSize: 17, fontWeight: 700,
              color: 'var(--text-primary)', lineHeight: 1.2,
            }}>{info.title}</h1>
            {info.sub && <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>{info.sub}</p>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              fontSize: 11, color: 'var(--text-muted)',
              background: 'var(--bg-elevated)', border: '1px solid var(--border)',
              borderRadius: 'var(--radius-sm)', padding: '4px 10px',
            }}>
              v1.0.0 · Constitution-Protected
            </div>
          </div>
        </header>

        {/* Page content */}
        <main style={{ flex: 1, padding: '28px', overflowY: 'auto' }} className="fade-in">
          {children}
        </main>
      </div>
    </div>
  );
}